import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ICard } from './card.interface';

import { ArrayService } from './../../../shared/service/array/array.service';

@Component({
    selector: 'mlp-ng-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class CardSharedComponent {
    @Input() layout = 'grid';
    @Input()
    set card(card: ICard) {
        if (card) {
            const split = this.arrService.splitArray(card.list);
            card.listSplit = split.firstArray;
            card.listSplitTwo = split.secondArray;

            this._cardData = card;
        }
    }

    get card(): ICard { return this._cardData; }

    get isGrid(): boolean {
        const isGrid = (this.layout === 'grid') ? true : false;

        return isGrid;
    }

    private _cardData: ICard;

    constructor(private arrService: ArrayService) {}
}
